<template>
  <div>
    <vs-popup class="extended-popup" title="" :active.sync="registrarPopupActive">
      <div class="vs-con-loading__container indented-section" id="regDiv-with-loading">
        <form class="mx-auto mt-5 inner-indented-section view-edit-partner-form" @submit.prevent="submit">
          <!-- Heading -->
          <div class="vx-row flex-wrap title-bar">
            <h3>{{ registrarModalHeading }}</h3>
          </div>

          <hr>

          <div class="vx-row mt-6">
            <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">Registrar Name *</label>
              <vs-input
                class="w-full"
                :v-validate="{ required: !formDataRegistrar['legal_name']}"
                name="Registrar Name"
                data-vv-validate-on="change"
                v-model="formDataRegistrar['legal_name']"
                :danger="errors.has('Registrar Name')"
                danger-text="Required field"
                v-bind:readonly="mode == 'view'"/>
            </div>

            <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">Registrar Short Name *</label>
              <vs-input
                class="w-full"
                :v-validate="{ required: !formDataRegistrar['name']}"
                name="Registrar Short Name"
                data-vv-validate-on="change"
                v-model="formDataRegistrar['name']"
                :danger="errors.has('Registrar Short Name') || (formDataRegistrar['name'] ? formDataRegistrar['name'].length : 0) > 50"
                :danger-text="errors.has('Registrar Short Name') ? (errors.items.find(x => x.field == 'Registrar Short Name').rule == 'required' ? 'Required field' : errors.items.find(x => x.field == 'Registrar Short Name').msg) : characterCount"
                v-bind:readonly="mode == 'view'"/>
            </div>

            <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">Account Manager</label>
              <v-select
                name="Account Manager"
                class="w-full"
                v-model="formDataRegistrar['accountManager']"
                :options="formAMs"
                :closeOnSelect="true"
                :clearable="false"
                v-bind:readonly="mode == 'view'"
                :noDrop="true"></v-select>
            </div>

            <div v-if="mode == 'edit'" class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">New Account Manager</label>
              <v-select
                name="New Account Manager"
                class="w-full"
                v-model="formDataRegistrar['newAccountManager']"
                :options="formAMs"
                :closeOnSelect="true"
                :clearable="false"
                :noDrop="mode == 'view'"></v-select>
            </div>

            <div v-if="mode == 'edit'" class="vx-col w-1/4 mt-4">
              <label class="vs-input--label inline-flex pb-2">Start Date {{ formDataRegistrar['accountManager'] !== formDataRegistrar['newAccountManager'] ? '*' : '' }}</label>
              <flat-pickr
                class="w-full"
                v-validate="{ required: formDataRegistrar['accountManager'] !== formDataRegistrar['newAccountManager']}"
                :required="formDataRegistrar['accountManager'] !== formDataRegistrar['newAccountManager']"
                data-vv-validate-on="change"
                name="Start Date"
                :config="configDateTimePicker"
                v-model="formDataRegistrar['start_date']"
                placeholder="YYYY-MM-DD" />

                <span v-if="errors.has('Start Date')" class="select-required-error--span span-text-validation"> Required field </span>
            </div>

            <div class="vx-col w-1/4" :class="mode == 'edit' ? 'mt-4' : ''">
              <label class="vs-input--label inline-flex pb-2">Country *</label>
              <v-select
                name="Country"
                class="w-full"
                v-model="formDataRegistrar['country']"
                :options="formGeo"
                :closeOnSelect="true"
                :clearable="false"
                v-validate="'required'"
                data-vv-validate-on="change"
                :noDrop="mode == 'view'" ></v-select>
            </div>
          </div>

          <div class="vx-row mt-4" v-for="(id, index) in formDataRegistrar['cnic_iana_ids']" :key="`CNICIANA-${index}`">
            <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">IANA ID</label>
              <vs-input
                class="w-full"
                type="number"
                :name="`IANA ID-${index}`"
                v-model="id['iana_id']" 
                v-bind:readonly="mode == 'view'"/>
            </div>

            <div class="vx-col w-1/4">
              <label class="vs-input--label inline-flex pb-2">CNIC ID</label>
              <vs-input
                class="w-full"
                :name="`CNIC ID-${index}`"
                v-model="id['cnic_id']" 
                v-bind:readonly="mode == 'view'" />
            </div>
          </div>

          <div v-if="mode !== 'view'">
            <div class="vx-row mt-4" v-for="(id, index) in formDataRegistrar['added_cnic_iana_ids']" :key="`NEW-CNICIANA-${index}`">
              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">IANA ID</label>
                <vs-input
                  class="w-full"
                  type="number"
                  :name="`IANA ID-${index}`"
                  v-model="id['iana_id']" />
              </div>

              <div class="vx-col w-1/4">
                <label class="vs-input--label inline-flex pb-2">CNIC ID</label>
                <vs-input
                  class="w-full"
                  :name="`CNIC ID-${index}`"
                  v-model="id['cnic_id']" />
              </div>

              <div>
                <vs-button
                  v-show="formDataRegistrar['added_cnic_iana_ids'].length > 1"
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  class="mt-8"
                  @click="removeIANACNICIDGroup(index)"></vs-button>
              </div>

              <div v-if="index == formDataRegistrar['added_cnic_iana_ids'].length - 1 && mode !== 'view'" class="vx-col w-1/4 mt-6">
                <vs-button color="black" type="filled" icon-pack="feather" icon="icon-plus" class="add-more-btn mt-1" @click="addIANACNICIDGroup()">Add</vs-button>
              </div>
            </div>
          </div>

          <hr class="my-6">

          <div v-if="mode !== 'view'" class="vx-row">
            <vs-button class="mt-2 ml-auto" type="filled" button="submit" icon-pack="feather" icon="icon-save">Save</vs-button>
          </div>
        </form>
      </div>
    </vs-popup>

    <!-- Error Prompt -->
    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <p>Please solve the following errors: <br><ul>{{ customPromptError }}</ul></p>
      </div>
    </custom-prompt>
    <!--  -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
  name: 'ViewOrEditCNICRegistrar',
  components: {
    "v-select": vSelect,
    flatPickr,
    CustomPrompt
  },
  data() {
    return {
      registrarPopupActive: false,
      registrarModalHeading: 'View Registrar Details',
      formDataRegistrar: {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'Select',
          value: null
        },
        newAccountManager: {
          label: 'Select',
          value: null
        },
        start_date: null,
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }],
        added_cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }]
      },
      configDateTimePicker: {
        maxDate: null,
        minDate: new Date(this.$moment(new Date()).subtract(9, 'months')),
        clickOpens: true
      },
      customPrompt: {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      },
      registrarId: null,
      mode: null,
      customPromptError: null
    }
  },
  mounted() {
    this.$root.$on('openCNICRegistrarPopup', (mode, id, data) => {
      this.registrarId = id;
      this.mode = mode;

      if(mode == 'edit') {
        this.registrarModalHeading = 'Edit Registrar Details';
      } else {
        this.registrarModalHeading = 'View Registrar Details';
      }

      this.formViewOrEditData(data);
      this.registrarPopupActive = true;
    })
  },
  computed: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    characterCount() {
      return 'Character Count: ' + (this.formDataRegistrar['name'] ? this.formDataRegistrar['name'].length : 0) + '/50';
    }
  },
  watch: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    registrarPopupActive(val) {
      if(!val) {
        this.resetForm();
      }
    }
  },
  methods: {
    formViewOrEditData(data) {
      this.formDataRegistrar['legal_name'] = data.unique_registrar_legal_name;
      this.formDataRegistrar['name'] = data.unique_registrar_shortname;
      this.formDataRegistrar['accountManager'] = this.formAMs.find(x => x.value == data.unique_registrar_user_id ) || {
        label: 'NA',
        value: null
      };
      this.formDataRegistrar['newAccountManager'] = this.formAMs.find(x => x.value == data.unique_registrar_user_id ) || {
        label: 'NA',
        value: null
      };
      this.formDataRegistrar['start_date'] = null;
      this.formDataRegistrar['country'] = this.formGeo.find(x => x.value == data.unique_registrar_country_id) || {
        label: 'NA',
        value: null
      };
      this.formDataRegistrar['cnic_iana_ids'] = (data.cnic_id || data.iana_id) ? (data.cnic_id ? data.cnic_id.split(',').map((x, index) => {
        return {
          cnic_id: x,
          iana_id: data.iana_id ? data.iana_id.split(',')[index] : null
        }
      }) : data.iana_id.split(',').map((x, index) => {
        return {
          cnic_id: data.cnic_id ? data.cnic_id.split(',')[index] : null,
          iana_id: x
        }
      })) :
      [{
        cnic_id: null,
        iana_id: null
      }]
    },
    addIANACNICIDGroup() {
      this.formDataRegistrar['added_cnic_iana_ids'].push({
        iana_id: null,
        cnic_id: null
      });
    },
    removeIANACNICIDGroup(index) {
      this.formDataRegistrar['added_cnic_iana_ids'].splice(index, 1);
    },
    submit() {
      this.$validator.validate().then(async valid => {
        if(valid) {
          let payload = {
            unique_registrar_id: this.registrarId,
            legal_name: this.formDataRegistrar['legal_name'],
            name: this.formDataRegistrar['name'],
            am_id: this.formDataRegistrar['newAccountManager'].value,
            start_date: this.formDataRegistrar['start_date'],
            country_id: this.formDataRegistrar['country'].value,
            website: this.formDataRegistrar['website'],
            cnic_iana_ids: this.formDataRegistrar['added_cnic_iana_ids'][0]['cnic_id'] && this.formDataRegistrar['added_cnic_iana_ids'][0]['iana_id'] ? this.formDataRegistrar['cnic_iana_ids'].concat(this.formDataRegistrar['added_cnic_iana_ids']) : this.formDataRegistrar['cnic_iana_ids']
          }
          
          await this.$axiosSecure.post('/unique-registrars/edit', payload)
          .then(response => {
            if(response.data.type == 'Success') {
              this.registrarPopupActive = false;
              this.$root.$emit('refreshRegistrarList');

              this.$vs.dialog({
                color: 'success',
                title: 'Success',
                text: 'Registrar edited successfully!',
                acceptText: 'Close',
                accept: () => {},
              });
            } else {
              let liStr = '';
              response.data.message.forEach((el, index) => {
                liStr += `${index+1}. ${el}`
              })
              this.customPromptError = liStr;
              this.customPrompt["type"] = "error";
              this.customPrompt["classList"] = "danger-prompt";
              this.customPrompt["color"] = "danger";
              this.customPrompt["activePrompt"] = true;
            }
          })
          .catch(error => {
            let liStr = '';
            error.response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          })
        } else {
          var errors = this.errors.collect();
        }
      })
    },
    resetForm() {
      this.formDataRegistrar = {
        legal_name: null,
        name: null,
        accountManager: {
          label: 'NA',
          value: null
        },
        newAccountManager: {
          label: 'NA',
          value: null
        },
        start_date: null,
        country: {
          label: 'NA',
          value: null
        },
        website: null,
        cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }],
       added_cnic_iana_ids: [{
          cnic_id: null,
          iana_id: null
        }]
      };

      this. customPrompt = {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      };

      this.configDateTimePicker = {
        maxDate: null,
        minDate: new Date(this.$moment(new Date()).subtract(9, 'months')),
        clickOpens: true
      };

      this.registrarId = null;
      this.mode = null;
    }
  },
  destroyed() {
    this.$root.$off('openCNICRegistrarPopup');
  }
}
</script>